<h1 mat-dialog-title>Rinomina {{toUpdate.subject}}</h1>
<div mat-dialog-content style="
    height: auto;
    min-height: 109px;">
    <form>
        <mat-form-field>
            <mat-label>Nome</mat-label>
            <input type="text" #name matInput [value]="toUpdate.name" maxlength = 50>
        </mat-form-field>
    </form>
  <div mat-dialog-actions>
    <button  mat-button [mat-dialog-close]="true" (click)="onYesClick(name.value)" [disabled]="name.value <= 0">Conferma</button>
    <button mat-button (click)="onNoClick()">Annulla</button>
  </div>
</div>
